import styles from './map.module.scss';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    addressData: string;
    isVisible?: boolean;
}

const mapsApiKey = 'AIzaSyDlFVjtq0rSwGyCdicse5gl9GXqnWFmGjI'; // TODO: Move to a config

export function Map({addressData, isVisible}: OwnProps) {
    const mapsUrl = `https://www.google.com/maps/embed/v1/place?zoom=14&key=${mapsApiKey}&q=${addressData}`;

    return (
        <div
            className={classNames(styles.map, {
                [styles.visible]: isVisible,
                [styles.hidden]: !isVisible && isVisible !== undefined,
            })}
        >
            <iframe width="100%" height="100%" style={{border: 0}} loading="lazy" allowFullScreen src={mapsUrl} />
        </div>
    );
}
